<template>
  <div class="item-div">
    <div v-if="list.length > 0" class='item' v-for="(item,index) in list" @click='selectBankTap(item)'
         :style='index == 0 ? "margin-top:12px;" : ""'>
      <img :src='$util.imgUrl(imageUrl,item.bgPic)' class='pg-img'/>
      <div class='bg'></div>
      <img :src='$util.imgUrl(imageUrl,item.pic)' class='logo'/>
      <span class='name'>{{item.bankName}}</span>
      <span class='card-type'>{{item.bankType == 1 ? '储蓄卡' : ''}}</span>
      <span class='card-num'>{{$util.bankCardShadow(item.bankCard)}}</span>
    </div>
    <div v-else class='item' style='align-items:center;'>
      <img style='margin-top:350px;width:200px;height:200px;' src="../../resource/img/pic_coupon_empty.png"/>
      <span style='color:#9B9B9B;margin-top:16px;'>暂无银行卡信息</span>
    </div>
    <div class="bottom">
      <div class='btn' @click='addTap'>添加银行卡</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MerTokerBankcardList',
  data () {
    return {
      title: '选择银行卡',
      pic: require('../../resource/img/bankpic.png'),
      bgPic: require('../../resource/img/bgpic.png'),
      list: [],
      queryData: {},
      imageUrl: sessionStorage.url
    }
  },
  created () {
    this.queryData = this.$route.query
  },
  mounted () {
    this.getList()
  },
  methods: {
    getList () {
      this.$api.post({
        url: '/system/bank-user/mer/list',
        data: {
          merId: this.queryData.merId,
          uid: this.queryData.uid
        },
        login: false
      }).then(res => {
        if (!this.$util.isArrOrNull(res.data)) {
          this.list = res.data
        }
      })
    },
    addTap () {
      this.$router.push({
        path: '/MerTokerAddBankCard',
        query: {
          merId: this.queryData.merId,
          storeId: this.queryData.storeId,
          fansid: this.queryData.fansid,
          uid: this.queryData.uid
        }
      })
    },
    //跳转到提现界面
    selectBankTap: function (item) {
      this.bankCard = item.bankCard
      this.bankId = item.id
      this.$router.back()
    }
  }
}
</script>

<style scoped>
  .item-div {
    width: 100%;
    height: auto;
    position: absolute;
    margin-top: 50px;
  }

  .item {
    display: flex;
    flex-direction: column;
    position: relative;
    align-items: center;
  }

  .item .pg-img {
    width: 380px;
    height: 150px;
  }

  .item .bg {
    width: 35px;
    height: 35px;
    background: rgba(255, 255, 255, 1);
    border-radius: 50%;
    position: absolute;
    top: 12px;
    left: 26px;
  }

  .item .logo {
    width: 29px;
    height: 29px;
    position: absolute;
    top: 15px;
    left: 29px;
    border-radius: 25%;
  }

  .item .name {
    position: absolute;
    top: 12px;
    left: 74px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    line-height: 22px;
  }

  .item .card-type {
    position: absolute;
    top: 34px;
    left: 74px;
    height: 16px;
    font-size: 12px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 16px;
  }

  .item .card-num {
    position: absolute;
    top: 75px;
    left: 74px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 22px;
  }

  .item .btn {
    position: absolute;
    top: 48px;
    right: 54px;
    height: 50px;
    line-height: 50px;
    padding: 0 13px;
    border-radius: 30px;
    color: #fff;
    border: 1px solid rgba(255, 255, 255, 1);
  }

  .bottom {
    z-index: 3;
    position: fixed;
    display: flex;
    justify-content: center;
    left: 0;
    width: 100%;
    bottom: 30px;
  }

  .bottom .btn {
    width: 70%;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background: linear-gradient(to right, #6C7FF6, #5A9BF5); /* 标准的语法 */
    border-radius: 20px;
    font-size: 17px;
    color: #fff;
  }

</style>



// WEBPACK FOOTER //
// src/components/active/MerTokerBankcardList.vue